module.exports = __webpack_public_path__ + "img/student_files_title.f338d1d0.png";